import React from 'react';
import { Card } from 'antd';

function DocsGetStartedCard({ t }) {
  return (
    <Card className="docs__item docs-item">
      <div className="docs-item__title">{t('where-to-begin')}</div>
      <div className="docs-item__content">
        <ol className="docs-item__list">
          <li>{t('where-to-begin-1')};</li>
          <li>{t('where-to-begin-2')};</li>
          <li>{t('where-to-begin-3')};</li>
          <li>{t('where-to-begin-4')};</li>
          <li>{t('where-to-begin-5')}</li>
        </ol>
      </div>
    </Card>
  );
}

export default DocsGetStartedCard;
